import moment from 'moment';

const filterEndTimeOptions = (options, startTime, startDate, endDate) => {
  if (!startDate || !endDate) return options;

  const isSameDay = moment(startDate).isSame(endDate, 'day');
  if (!isSameDay || !startTime?.value) return options;

  return options.filter((option) => option.value > startTime.value);
};

export default filterEndTimeOptions;
